import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { clearAuthCookies } from '../utils/authCookies';
import { loginUser } from "../service/login";
import { checkUserSession, getCSRFToken, refreshUserSession } from '../service/auth';
import { fetchCurrentUser, logoutUser } from '../services/authService';
export const getLogin = createAsyncThunk(
  "/login",
  async (_, { rejectWithValue }) => {
    try {
      const response = await loginUser()
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCSRFTokens = createAsyncThunk(
  "/csrf-token",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCSRFToken()
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const checkSession = createAsyncThunk(
  "checksession/fetch",
  async ( _,{ rejectWithValue }) => {
    try {
      const response = await checkUserSession()
     return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const refreshSession = createAsyncThunk(
  "refreshsession/fetch",
  async ( _,{ rejectWithValue }) => {
    try {
      const response = await refreshUserSession()
     return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCurrentUser = createAsyncThunk(
  'auth/getCurrentUser',
  async (_, { rejectWithValue }) => {
    try {
      const user = await fetchCurrentUser();
      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Logs the user out: calls backend to clear auth cookies, then clears local
// client-side state. The actual redirect to "/" is handled by the caller so
// it can happen after the reducer resets state.
export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      await logoutUser();
    } catch (error) {
      // Even if the server call fails, we still proceed to clear client
      // state — a stale session on the server is better than a stuck UI.
      console.warn('Logout API call failed, clearing client state anyway:', error);
    }

    try {
      clearAuthCookies();
    } catch (error) {
      return rejectWithValue(error);
    }

    return true;
  }
);

// Auth slice
const AuthSlice = createSlice({
  name: 'auth',
  initialState: { isAuthenticated: false, user: null, error: null ,status:"", logoutStatus:""},
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkSession.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkSession.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessionChecked = true;
      })
      .addCase(checkSession.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error;
        state.sessionChecked = true;
      })
      .addCase(getCurrentUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(getCurrentUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error;
      })
      .addCase(logout.pending, (state) => {
        state.logoutStatus = "loading";
      })
      .addCase(logout.fulfilled, (state) => {
        state.status = "";
        state.logoutStatus = "succeeded";
        state.isAuthenticated = false;
        state.user = null;
        state.error = null;
        state.sessionChecked = false;
      })
      .addCase(logout.rejected, (state, action) => {
        state.logoutStatus = "failed";
        state.error = action.error;
      });
  },
});

// Export actions
export default AuthSlice.reducer
